<!-- room picker header only on mobile -->
<div class="room-picker-header col-12 my-3">
    <h3>{{"sm.SelectRoomsAndOccupants" | translate}}</h3>
    <div class="close-room-picker">
        <p-button [rounded]="true" [text]="true" (click)="closeRoomPicker()">
            <span class="material-symbols-outlined">cancel</span>
        </p-button>
    </div>
</div>


@for (room of rooms; track $index; let roomIndex = $index) {
    <div class="room-occupants">
        <div class="room-title">
            <label [class.room-label-margin-fill]="roomIndex == 0">{{"sm.Room"|translate}} {{roomIndex +1}}</label>
            @if (roomIndex > 0)
            {
                <p-button icon="pi pi-check" [rounded]="true" [text]="true" (click)="removeRoom(roomIndex)">
                    <span class="material-symbols-outlined">close</span>
                </p-button>
            }
        </div>

        <div class="row">
            <div [class]="canBookChildren ? 'col-6' : 'col-12'">
                <label class="d-block">{{"sm.Adults"|translate}}</label>
                <app-incrementor
                    [value]="rooms[roomIndex].adults"
                    [minValue]=1
                    [maxValue]="maxAdults"
                    [hasMaxPersons]="maxPersonError[roomIndex]"
                    maxErrorText="{{'sm.MaxAdultCountError' |translate:{value:maxAdults} }}"
                    (onChange)="changeAdults($event, roomIndex)"
                    dataTestId="adults-room-{{roomIndex}}"
                ></app-incrementor>
            </div>
            @if (canBookChildren) {
                <div class="col-6">
                    <label class="d-block">{{"sm.Children" | translate}}</label>
                    <app-incrementor
                        [value]="rooms[roomIndex].children"
                        [minValue]=0
                        [maxValue]="maxChildren"
                        [hasMaxPersons]="maxPersonError[roomIndex]"
                        maxErrorText="{{'sm.MaxChildCountError' |translate:{value:maxChildren} }}"
                        (onChange)="changeChildren($event, roomIndex)"
                        dataTestId="children-room-{{roomIndex}}"
                    ></app-incrementor>
                </div>
            }
            @if (maxPersonError[roomIndex]) {
                <div class="error-text" [attr.data-testid]="'room-' + roomIndex + '-maxPersonError'">{{'sm.MaxPersonCountError'|translate:{value:maxPersons} }}</div>

            }
        </div>
        @if (room.children > 0) {
            <div class="row mt-2">
                @for (i of room.childAges; track $index) {

                    <div [class.col-4]="$count == 3" [class.col-6]="$count == 2" [class.col-12]="$count == 1">
                        <label class="d-block">{{'sm.ChildAge' | translate:{value: $index + 1} }}</label>
                        <p-select class="childAgeInput" [ngModel]="rooms[roomIndex].childAges[$index]" (onChange)="changeChildAge($event, roomIndex, $index)"
                            [options]="getChildrenAgeConfig()" optionLabel="label" optionValue="value"
                            [placeholder]="'sm.ChooseAge' | translate"
                            [attr.data-testid]="'child-age-room-' + roomIndex + '-index-' + $index">
                            <ng-template #dropdownicon>
                                <p-button icon="pi pi-check" aria-label="Toggle dropdown" [rounded]="true" [text]="true">
                                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                                </p-button>
                            </ng-template>
                        </p-select>
                        @if (i === null) {
                            <div class="error-text">{{"sm.ChildAgesRequired" | translate}}</div>
                        }

                    </div>
                }
            </div>
        }


    </div>
}
<div class="occupancy-footer"> 
    <p-button (click)="addRoom()" outlined [class.invisible]="settings.get('searchMask.maxRooms') == 1" [disabled]="rooms.length >= (settings.get('searchMask.maxRooms') ?? 4)" [attr.data-testid]="'add-room'">{{"sm.AddRoom"|translate}}</p-button>
    <p-button (click)="closeRoomPicker()" [disabled]="hasUnselectedChildAges()" [attr.data-testid]="'close-room-picker'">{{"sm.Confirm"|translate}}</p-button>
</div>
